/* global axios */
import ApiClient from '../ApiClient';

// Conectar e-mail na aba Canais sociais. O Rails repassa ao Laravel, que testa
// envio e recebimento, grava o SMTP e cria a caixa da Caixa de Entrada.
class EmailIntegration extends ApiClient {
  constructor() {
    super('aceleres/email_integration', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  connect(payload) {
    return axios.post(`${this.url}/connect`, payload, { timeout: 70000 });
  }

  googleAuthorizationUrl() {
    return axios.post(`${this.url}/google/authorize`);
  }

  remove(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new EmailIntegration();
